import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from "react";

import XIcon from "@heroicons/react/solid/XIcon";
import { classNames } from "../../../utils/Utils";
import {useTranslation} from "react-i18next";

export default function IframePopup({ isOpen, setIsOpen, trackingLink }) {

    const { t } = useTranslation();

    const openInNewTab = () => {
        if (trackingLink) window.open(trackingLink, "_blank", "noopener,noreferrer");
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 z-[400] overflow-y-auto" onClose={setIsOpen}>
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
                        leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 z-[390] bg-gray-900 bg-opacity-30 transition-opacity" />
                    </Transition.Child>

                    <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"
                    >
                        <div className="relative z-[400] inline-block w-full max-w-2xl my-8 text-left align-middle transition-all transform bg-white shadow-xl">
                            <div className="flex justify-between border-b p-4 items-center">

                                <div
                                    className="text-amber-900 text-sm">
                                    {trackingLink && (
                                        <>
                                            {" "}
                                            <button
                                                type="button"
                                                onClick={openInNewTab}
                                                className="underline font-medium"
                                            >
                                                {t("app.shipping_tracking.site_error_btn")}
                                            </button>
                                        </>
                                    )}
                                </div>
                                <button className="bg-white border-0" onClick={() => setIsOpen(false)}>
                                    <XIcon className="w-4 h-4 fill-current flex-shrink-0 text-blue-1000"/>
                                </button>
                            </div>


                            {/* Iframe (mostrato solo quando caricato) */}
                            <div
                                className={classNames(
                                    "block w-full shadow-md aspect-w-10 aspect-h-10  overflow-hidden"
                                )}
                            >
                                <iframe
                                    id="IframeShipsgoLiveMap"
                                    src={trackingLink}
                                    title="Live Map"
                                    style={{ width: "100%", height: "600px", border: "none" }}
                                />
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
